import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
export function Testimonials() {
  const ref = useScrollAnimation();
  const testimonials = [{
    name: 'Laura G.',
    role: 'Docente de Arte, Primaria',
    initial: 'L',
    quote: '¡Increíble material! Me salvó el año. Las actividades son súper creativas y a los chicos les encantan.'
  }, {
    name: 'Martín R.',
    role: 'Profesor de Artística, Secundaria',
    initial: 'M',
    quote: 'La sección de secundaria es muy completa. Los proyectos están muy bien estructurados paso a paso.'
  }, {
    name: 'Sofía P.',
    role: 'Tallerista Independiente',
    initial: 'S',
    quote: 'Las planificaciones anuales me salvaron. Me permite tener todo organizado y variar mis clases siempre.'
  }];
  return <section id="testimonios" className="w-full bg-[#0a0a0a] py-24 px-4 border-t border-[#1a1a1a]" ref={ref} data-id="element-201">
      <div className="max-w-6xl mx-auto" data-id="element-202">
        <div className="scroll-hidden text-center mb-16" data-id="element-203">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4" style={{
          fontFamily: 'Georgia, serif'
        }} data-id="element-204">
            Lo que dicen los docentes
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-205">
          {testimonials.map((testimonial, index) => <div key={index} className="scroll-hidden bg-[#141414] border border-[#2a2a2a] rounded-xl p-8" style={{
          transitionDelay: `${index * 100}ms`
        }} data-id="element-206">
              <div className="flex text-[#F5C518] mb-6 text-xl" data-id="element-207">★★★★★</div>
              <p className="text-gray-300 leading-relaxed italic mb-8 text-lg" data-id="element-208">
                "{testimonial.quote}"
              </p>
              <div className="flex items-center mt-auto" data-id="element-209">
                <div className="w-12 h-12 rounded-full bg-[#2a2a2a] flex items-center justify-center text-white font-bold text-lg" data-id="element-210">
                  {testimonial.initial}
                </div>
                <div className="ml-4" data-id="element-211">
                  <h3 className="font-bold text-white" data-id="element-212">{testimonial.name}</h3>
                  <p className="text-sm text-gray-500" data-id="element-213">{testimonial.role}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}